import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebCheckingService {

  internal_partner = [
    {
      name: 'Air Arabia',
      logo: 'assets/airline_partner/Air_Arabia.png',
      check_flight_status:[{
        link: 'https://www.airarabia.com/en/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. IB075 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://webcheckin.airarabia.com/accelaero/en/index.html#/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airarabia.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airarabia.com/en/contact-us',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    // {
    //   name: 'air asia',
    //   logo: 'assets/airline_partner/AirAsia.png',
    //   check_flight_status:[{
    //     link: 'https://www.airasia.com/flightstatus',
    //     content:[
    //       {
    //         data: 'Input the Departing, Arrival and flight number, e.g. I53603 Or Search by Route '
    //       },
    //       {
    //         data: 'Click on Search Flights '
    //       }
    //     ],
    //     note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
    //   }],
    //   web_check_in:[{
    //     link: 'https://www.airasia.com/check-in',
    //     content:[
    //       {
    //         data: 'Input the PNR and Email/Last Name as per the booking '
    //       },
    //       {
    //         data: 'Select the passenger and add Nationality '
    //       },
    //       {
    //         data: 'Tick to complete the Covid-19 and other self-declarations '
    //       },
    //       {
    //         data: 'Select add ons (Seats, Baggage, etc.) and continue '
    //       }
    //     ],
    //     note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airasia.co.in/home and input the PNR details which they have already checked in.',
    //   }],
    //   update_contact:[{
    //     link: 'https://www.airasia.com/member/search',
    //     content:[
    //       {
    //         data: 'Input the PNR, Email/Last Name & Click on Update Contact'
    //       }
    //     ],
    //     note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
    //   }],
    // },
    {
      name: 'Air India',
      logo: 'assets/airline_partner/Air-India.svg',
      check_flight_status:[{
        link: 'https://www.airindia.com/in/en/manage/flight-status.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AI161 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airindia.com/in/en/manage/web-checkin.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airindia.in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.bookme.airindia.in/AirIndiaB2C/Manage/Retrieve',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air India Express',
      logo: 'assets/airline_partner/Air_India_Ex.png',
      check_flight_status:[{
        link: 'https://www.airindiaexpress.in/en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. I53603 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://travel.airindia.in/ssci/identification',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airindiaexpress.in/en  and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airindiaexpress.in/en/contact-us/our-offices',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
   
    {
      name: 'indigo',
      logo: 'assets/airline_partner/indigo.svg',
      check_flight_status:[{
        link: 'https://goindigo.in/check-flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. 6E007 Or Search by Route '
          },
          {
            data: 'Click on Search Flights '
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.goindigo.in/web-check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit www.goindigo.in and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.goindigo.in/update-contact-details',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Scoot',
      logo: 'assets/airline_partner/Scoot.svg',
      check_flight_status:[{
        link: 'https://flightstatus.flyscoot.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. TR623 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://makeabooking.flyscoot.com/checkin',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.flyscoot.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.flyscoot.com/en/support/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'spicejet',
      logo: 'assets/airline_partner/spicejet.png',
      check_flight_status:[{
        link: 'https://book.spicejet.com/flightstatus.aspx',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SJ3092 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://book.spicejet.com/CheckIn.aspx',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.spicejet.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.book.spicejet.com/RetrieveBooking',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    // {
    //   name: 'Vistara',
    //   logo: 'assets/airline_partner/Vistara_Logo.png',
    //   check_flight_status:[{
    //     link: 'https://www.airvistara.com/in/en',
    //     content:[
    //       {
    //         data: 'Input the Departing, Arrival and flight number, e.g. UK017 Or Search by Route '
    //       },
    //       {
    //         data: 'Click on Search Flights'
    //       }
    //     ],
    //     note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
    //   }],
    //   web_check_in:[{
    //     link: 'https://www.airvistara.com/in/en',
    //     content:[
    //       {
    //         data: 'Input the PNR and Email/Last Name as per the booking '
    //       },
    //       {
    //         data: 'Select the passenger and add Nationality '
    //       },
    //       {
    //         data: 'Tick to complete the Covid-19 and other self-declarations '
    //       },
    //       {
    //         data: 'Select add ons (Seats, Baggage, etc.) and continue '
    //       }
    //     ],
    //     note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit www.airvistara.com/in/en and input the PNR details which they have already checked in.',
    //   }],
    //   update_contact:[{
    //     link: 'https://www.airvistara.com/in/en',
    //     content:[
    //       {
    //         data: 'Input the PNR, Email/Last Name & Click on Update Contact'
    //       }
    //     ],
    //     note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
    //   }],
    // },
    {
      name: 'Aeroflot',
      logo: 'assets/airline_partner/aeroflot.svg',
      check_flight_status:[{
        link: 'https://www.aeroflot.ru/xx-en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SU103 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.aeroflot.ru/ru-en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 4 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.aeroflot.ru/xx-en and input the PNR details which they have already checked in.',
      }]
    },
    {
      name: 'astana',
      logo: 'assets/airline_partner/astana.svg',
      check_flight_status:[{
        link: 'https://airastana.com/ind/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. KC286 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://airastana.com/ind/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://airastana.com/ind/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://airastana.com/ind/en-us/About-Us/Press-Office/Contact-Us',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air canada',
      logo: 'assets/airline_partner/ac.svg',
      check_flight_status:[{
        link: 'https://www.aircanada.com/us/en/aco/home.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AC51 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.aircanada.com/us/en/aco/home.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.aircanada.com/ca/en/aco/home.html  and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.aircanada.com/ca/en/aco/home/fly/customer-support.html#/',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air China',
      logo: 'assets/airline_partner/air-China.svg',
      check_flight_status:[{
        link: 'https://www.airchina.co.in/IN/GB/info/flight-status/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. CA908 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airchina.co.in/IN/GB/booking/online-check-in/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airchina.co.in/IN/GB/Home and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airchina.co.in/IN/GB/contact-us/',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air France',
      logo: 'assets/airline_partner/air-France.svg',
      check_flight_status:[{
        link: 'https://wwws.airfrance.in/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AF264 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://wwws.airfrance.in/check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://wwws.airfrance.in/ and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://wwws.airfrance.in/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air macau',
      logo: 'assets/airline_partner/air_Macau.svg',
      check_flight_status:[{
        link: 'https://www.airmacau.com.mo/#/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. I5798 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airmacau.com.mo/#/checkIn/home',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airmacau.com.mo/#/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airmacau.com.mo/#/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'air Madagascar',
      logo: 'assets/airline_partner/air_Madagascar.svg',
      check_flight_status:[{
        link: 'https://madagascarairlines.com/en/air-madagascar.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. MD258 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://madagascarairlines.com/en/air-madagascar.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://madagascarairlines.com/en and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://madagascarairlines.com/en/tsaradia/contact-us.html',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'air Mauritius',
      logo: 'assets/airline_partner/air-Mauritius.svg',
      check_flight_status:[{
        link: 'https://www.airmauritius.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. MK201 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airmauritius.com/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airmauritius.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'air New Zealand',
      logo: 'assets/airline_partner/air_New_Zealand.svg',
      check_flight_status:[{
        link: 'https://www.airnewzealand.com.sg/india',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. NZ063 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airnewzealand.com.sg/india',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airnewzealand.com.sg/india and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airnewzealand.com.sg/help-and-contact  https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'air Seychelles',
      logo: 'assets/airline_partner/air_Seychelles.svg',
      check_flight_status:[{
        link: 'https://www.airseychelles.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. HM 061 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airseychelles.com/en/before-you-fly/web-checkin',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airseychelles.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airseychelles.com/en/about-us/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'alitalia',
      logo: 'assets/airline_partner/alitalia.svg',
      check_flight_status:[{
        link: 'https://www.alitalia.com/en/flights-from-india',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AZ067 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.ita-airways.com/en_en/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.alitalia.com/en/flights-from-india and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.ita-airways.com/en_en/support/contact-assistance/customer-center.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'nippon Airways',
      logo: 'assets/airline_partner/nippon_Airways.svg',
      check_flight_status:[{
        link: 'https://www.ana.co.jp/en/in/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. NH205 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.ana.co.jp/en/in/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.ana.co.jp/en/in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.ana.co.jp/en/in/help/  https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'american airline',
      logo: 'assets/airline_partner/aa.svg',
      check_flight_status:[{
        link: 'https://www.americanairlines.in/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AA001 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.americanairlines.in/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.americanairlines.in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.americanairlines.in/i18n/customer-service/contact-american/american-customer-service.jsp?locale=en_INhttps://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'apg',
      logo: 'assets/airline_partner/apg.svg',
      check_flight_status:[{
        link: 'https://www.apg-airlines.com/search?lang=en_US',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. FI108 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://book.apg-airlines.com/web/ICIPNRSearch.xhtml?localeuage=en_US',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.apg-airlines.com/search?lang=en_US and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.apg-airlines.com/contact?lang=en_US https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'asiana Airlines',
      logo: 'assets/airline_partner/asiana_Airlines.svg',
      check_flight_status:[{
        link: 'https://flyasiana.com/C/IN/EN/index',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. OZ988 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://flyasiana.com/C/IN/EN/index',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://flyasiana.com/C/IN/EN/index and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.apg-airlines.com/contact?lang=en_US https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'bangkol airways',
      logo: 'assets/airline_partner/bangkol_airwaus.svg',
      check_flight_status:[{
        link: 'https://www.bangkokair.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. PG829 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.bangkokair.com/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.bangkokair.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.bangkokair.com/about-us/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'biman Bangladesh Airlines',
      logo: 'assets/airline_partner/biman_Bangladesh_Airlines.svg',
      check_flight_status:[{
        link: 'https://www.biman-airlines.com/#flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. BG997 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.biman-airlines.com/#check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.biman-airlines.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.biman-airlines.com/contactus?#domestic https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'brussels airlines',
      logo: 'assets/airline_partner/brussels_airlines.svg',
      check_flight_status:[{
        link: 'https://www.brusselsairlines.com/us/en/homepage',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SN082 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.brusselsairlines.com/us/en/homepage',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.brusselsairlines.com/us/en/homepage and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.brusselsairlines.com/us/en/contact https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Cathay Pacific',
      logo: 'assets/airline_partner/Cathay-Pacific.svg',
      check_flight_status:[{
        link: 'https://www.cathaypacific.com/cx/en_IN.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. CX160 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.cathaypacific.com/mb/#/en_IN/olci/login',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.cathaypacific.com/cx/en_IN.html and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.cathaypacific.com/cx/en_IN/contact-us.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'china Airlines',
      logo: 'assets/airline_partner/china-Airlines.svg',
      check_flight_status:[{
        link: 'https://www.china-airlines.com/tw/en/fly/flight-status/index',
        content:[
          {
            data: 'nput the Departing, Arrival and flight number, e.g. CI297 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://calec.china-airlines.com/echeckin_tn/eCheckin_home.aspx?country=tw&locale=en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.china-airlines.com/tw/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.china-airlines.com/tw/en/contact-us/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'china Eastern Airlines',
      logo: 'assets/airline_partner/china_Eastern_Airlines.svg',
      check_flight_status:[{
        link: 'https://us.ceair.com/en/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. MU781 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://us.ceair.com/en/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://us.ceair.com/en/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://us.ceair.com/newCMS/us/en/content/en_Header/HeaderTop/201903/t20190305_2721.html https://www.airmauritius.com/contact ',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'china Southern',
      logo: 'assets/airline_partner/china-Southern.svg',
      check_flight_status:[{
        link: 'https://www.csair.com/in/en/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. CZ784 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.csair.com/in/en/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.csair.com/in/en/ and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.csair.com/in/en/contact/service/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'delta',
      logo: 'assets/airline_partner/delta.svg',
      check_flight_status:[{
        link: 'https://www.delta.com/apac/en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. DL006 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.delta.com/apac/en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.delta.com/apac/en and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.delta.com/apac/en https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'egyptAir',
      logo: 'assets/airline_partner/egyptAir.svg',
      check_flight_status:[{
        link: 'https://www.egyptair.com/en/Pages/HomePage.aspx',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. MS201 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.egyptair.com/en/fly/check-in/Pages/web-check-in.aspx',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.egyptair.com/en/Pages/HomePage.aspx and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.egyptair.com/en/contact-us/Pages/default.aspx https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'elal',
      logo: 'assets/airline_partner/page_01.svg',
      check_flight_status:[{
        link: 'https://www.elal.com/en/PassengersInfo/Useful-Info/Flight-Schedule/Pages/Flight-Updates.aspx?FlightsUpdates=True',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. LY114 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.elal.com/checkin/home/identification/c?language=eng',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.elal.com/en/India/Pages/default.aspx and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.elal.com/en/About-ELAL/Contact-Us/Pages/default.aspxhttps://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'emirates',
      logo: 'assets/airline_partner/emirates.svg',
      check_flight_status:[{
        link: 'https://www.emirates.com/in/english/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. EK2405 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.emirates.com/in/english/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.emirates.com/in/english/ and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.emirates.com/in/english/help/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'ethiopian Airlines',
      logo: 'assets/airline_partner/ethiopian_Airlines.svg',
      check_flight_status:[{
        link: 'https://www.ethiopianairlines.com/in/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. ET693 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.ethiopianairlines.com/in/book/trip/web-check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.ethiopianairlines.com/in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.ethiopianairlines.com/in/services/help-and-contact https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'etihad airways',
      logo: 'assets/airline_partner/etihad-airways.svg',
      check_flight_status:[{
        link: 'https://www.etihad.com/en-in/manage/flight-tracker',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. EY867 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.etihad.com/en-in/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.etihad.com/en-in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.etihad.com/en-in/help/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'evaair',
      logo: 'assets/airline_partner/evaair.svg',
      check_flight_status:[{
        link: 'https://www.evaair.com/en-global/index.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. BR695 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.evaair.com/en-global/index.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.evaair.com/en-global/index.html and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.evaair.com/en-global/customer-services/contact-us/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'fiji Airways',
      logo: 'assets/airline_partner/fiji_Airways.svg',
      check_flight_status:[{
        link: 'https://www.fijiairways.com/en-us/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. FJ210 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.fijiairways.com/en-us/	',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.fijiairways.com/en-us/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.fijiairways.com/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'finnaair',
      logo: 'assets/airline_partner/finnaair.svg',
      check_flight_status:[{
        link: 'https://www.finnair.com/in-en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AY99 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.finnair.com/in-en/check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.finnair.com/in-en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.finnair.com/in-en/customer-care-and-contact-information https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    
    {
      name: 'garuda Indonesia',
      logo: 'assets/airline_partner/garuda_Indonesia.svg',
      check_flight_status:[{
        link: 'https://www.garuda-indonesia.com/sg/en/index',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. GA326 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://checkin.si.amadeus.net/1ASIHSSCWEBGA/sscwga/checkin?ln=en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.garuda-indonesia.com/sg/en/index and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.garuda-indonesia.com/sg/en/contact/index https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'gulf Air',
      logo: 'assets/airline_partner/gulf_Air.svg',
      check_flight_status:[{
        link: 'https://www.gulfair.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. GF125 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.gulfair.com/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.gulfair.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.gulfair.com/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'hahn',
      logo: 'assets/airline_partner/hahn.svg',
      check_flight_status:[{
        link: 'https://www.hahnair.com/en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. HR1432 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.hahnair.com/en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.hahnair.com/en and input the PNR details which they have already checked in. ',
      }],
      update_contact:[{
        link: 'https://www.hahnair.com/en/contact https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'japan Airlines',
      logo: 'assets/airline_partner/japan_Airlines.svg',
      check_flight_status:[{
        link: 'https://www.jal.co.jp/in/en/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. JL134 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.jal.co.jp/in/en/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.jal.co.jp/in/en/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.jal.co.jp/jp/en/information/branch/sr/in/?m=footer https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'jazeera',
      logo: 'assets/airline_partner/jazeera.svg',
      check_flight_status:[{
        link: 'https://www.jazeeraairways.com/en-in',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. J9366 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.jazeeraairways.com/en-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.jazeeraairways.com/en-in and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.jazeeraairways.com/en-in/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'jetstar',
      logo: 'assets/airline_partner/jetstar.svg',
      check_flight_status:[{
        link: 'https://booking.jetstar.com/flight-status/?culture=en-au',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. 3K375 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://checkin.jetstar.com/au/en/checkin?pid=secondnav:check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.jetstar.com/au/en/about-us/jetstar-group/jetstar-asia and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.jetstar.com/au/en/contact-us?pid=mainfooter:contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'kenya',
      logo: 'assets/airline_partner/kenya.svg',
      check_flight_status:[{
        link: 'https://www.kenya-airways.com/en/book-manage/flight-status/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. KQ706 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.kenya-airways.com/en/book-manage/post-booking/check-in/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.kenya-airways.com/in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.kenya-airways.com/contacts/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'klm',
      logo: 'assets/airline_partner/klm.svg',
      check_flight_status:[{
        link: 'https://www.klm.co.in/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. KL074 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.klm.co.in/check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.klm.co.in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.klm.co.in/contact https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'korean Air',
      logo: 'assets/airline_partner/koreanAir.svg',
      check_flight_status:[{
        link: 'https://www.koreanair.com/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. KE001 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.koreanair.com/check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.koreanair.com/us/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.koreanair.com/us/en/footer/customer-support/service-center https://www.airmauritius.com/contact ',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'kuwait Airways',
      logo: 'assets/airline_partner/kuwait_Airways.svg',
      check_flight_status:[{
        link: 'https://www.kuwaitairways.com/en/flightstatus',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. KU229 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.kuwaitairways.com/en/online-checkin',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.kuwaitairways.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.kuwaitairways.com/en/contact/contactus https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'latam',
      logo: 'assets/airline_partner/latam.svg',
      check_flight_status:[{
        link: 'https://www.kuwaitairways.com/en/flightstatus',
        content:[
          {
            data: 'https://www.latamairlines.com/us/en/flight-status'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.latamairlines.com/us/en/check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.latamairlines.com/us/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.latamairlines.com/uy/en/about-latam/contact-center https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'lot',
      logo: 'assets/airline_partner/lot.svg',
      check_flight_status:[{
        link: 'https://www.lot.com/in/en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. LO080 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.lot.com/in/en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.lot.com/in/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.lot.com/in/en/help-center/contact https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'lufthansa',
      logo: 'assets/airline_partner/lufthansa.svg',
      check_flight_status:[{
        link: 'https://www.lufthansa.com/in/en/homepage',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. LH220 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.lufthansa.com/in/en/homepage',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.lufthansa.com/in/en/homepage and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.lufthansa.com/in/en/help-and-contact https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'malaysia',
      logo: 'assets/airline_partner/malaysia.svg',
      check_flight_status:[{
        link: 'https://www.malaysiaairlines.com/in/en.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. MH232 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.malaysiaairlines.com/in/en.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.malaysiaairlines.com/in/en.html and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.malaysiaairlines.com/in/en/help/contact-us.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'batik air',
      logo: 'assets/airline_partner/batik_air.svg',
      check_flight_status:[{
        link: 'https://www.malindoair.com/in/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. OD325 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.malindoair.com/in/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.malindoair.com/in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.malindoair.com/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'nepal',
      logo: 'assets/airline_partner/nepal.svg',
      check_flight_status:[{
        link: 'https://www.nepalairlines.com.np/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. RA284 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.nepalairlines.com.np/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.nepalairlines.com.np/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.nepalairlines.com.np/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'oman air',
      logo: 'assets/airline_partner/oman_air.svg',
      check_flight_status:[{
        link: 'https://www.omanair.com/gbl/en/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. WY910 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.omanair.com/in/en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.omanair.com/in/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.omanair.com/gbl/en/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'philippine Airlines',
      logo: 'assets/airline_partner/philippine-Airlines.svg',
      check_flight_status:[{
        link: 'https://www.philippineairlines.com/en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. PR329 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.philippineairlines.com/en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.philippineairlines.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.philippineairlines.com/en/aboutus/contactus https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'qantas',
      logo: 'assets/airline_partner/qantas.svg',
      check_flight_status:[{
        link: 'https://www.qantas.com/in/en.html?tabId=flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. QF329 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.qantas.com/in/en.html?tabId=check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.qantas.com/in/en.html and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.qantas.com/au/en/support/contact-us.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'qatar Airways',
      logo: 'assets/airline_partner/qatar-Airways.svg',
      check_flight_status:[{
        link: 'https://www.qatarairways.com/en-in/homepage.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. QR157 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.qatarairways.com/en-in/homepage.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.qatarairways.com/en-in/homepage.html and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.qatarairways.com/en-in/help.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Royal Brunei Airlines',
      logo: 'assets/airline_partner/Royal-Brunei-Airlines.svg',
      check_flight_status:[{
        link: 'https://www.flyroyalbrunei.com/brunei/en/#flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. BI309 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.flyroyalbrunei.com/brunei/en/#check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.flyroyalbrunei.com/brunei/en/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.flyroyalbrunei.com/brunei/en/help-support/contact-us/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'royal jordanian',
      logo: 'assets/airline_partner/royal_jordanian.svg',
      check_flight_status:[{
        link: 'https://rj.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. RJ520 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://rj.com/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://rj.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://rj.com/en/contact-us/e-mail-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'saudia',
      logo: 'assets/airline_partner/saudia.svg',
      check_flight_status:[{
        link: 'https://www.saudia.com/travel-with-saudia/book-with-us/flight-schedule',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SV321 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.saudia.com/travel-with-saudia/manage/web-check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.saudia.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.saudia.com/help/contact-us/call-centers https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'scandinavian Airlines',
      logo: 'assets/airline_partner/scandinavian-Airlines.svg',
      check_flight_status:[{
        link: 'https://www.flysas.com/travel/flightstatus/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SK117 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.flysas.com/en/checkin/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.flysas.com/en/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.flysas.com/en/customer-service/contact/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'shandong Airlines',
      logo: 'assets/airline_partner/shandong_Airlines.svg',
      check_flight_status:[{
        link: 'https://www.sda.cn/dyflight/search.shtml?lang=en',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SC324 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.sda.cn/en/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.sda.cn/en/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.sda.cn/en/tips/Face.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'singapore airline',
      logo: 'assets/airline_partner/singapore_airline.svg',
      check_flight_status:[{
        link: 'https://www.singaporeair.com/en_UK/in/home#/flightstatus',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. MI629 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.singaporeair.com/en_UK/in/home#/checkin',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.singaporeair.com/en_UK/in/home#/book/bookflight and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.singaporeair.com/en_UK/contact-us/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'South African Airways',
      logo: 'assets/airline_partner/South-African-Airways-logo.svg',
      check_flight_status:[{
        link: 'https://www.flysaa.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SA083 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.flysaa.com/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.flysaa.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.flysaa.com/help/customer-support/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'sriLankan Airlines',
      logo: 'assets/airline_partner/sriLankan_Airlines.svg',
      check_flight_status:[{
        link: 'https://www.srilankan.com/en_uk/plan-and-book/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. UL603 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.srilankan.com/online-checkin',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.srilankan.com/en_uk/in and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.srilankan.com/en_uk/flying-with-us/contact-us 	https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'sswiss International Air Lines',
      logo: 'assets/airline_partner/swiss_International_Air_Lines.svg',
      check_flight_status:[{
        link: 'https://www.swiss.com/in/en/homepage',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. LX329 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.swiss.com/in/en/homepage',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.swiss.com/in/en/homepage and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.swiss.com/in/en/customer-support/contact-us 	https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'TAP Portugal',
      logo: 'assets/airline_partner/TAP-Portugal-Logo.svg',
      check_flight_status:[{
        link: 'https://www.flytap.com/en-pt/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. TP302 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.flytap.com/en-pt/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.flytap.com/en-pt/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.flytap.com/en-pt/support/contacts https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'thai Airways',
      logo: 'assets/airline_partner/thai-Airways.svg',
      check_flight_status:[{
        link: 'https://www.thaiairways.com/en_IN/index.page',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. TG906 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.thaiairways.com/en_IN/index.page',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.thaiairways.com/en_IN/index.page and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.thaiairways.com/en_IN/contact_us/index.page? https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
   
    {
      name: 'turkish Airlines',
      logo: 'assets/airline_partner/turkish_Airlines.svg',
      check_flight_status:[{
        link: 'https://www.turkishairlines.com/',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. TK235 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.turkishairlines.com/',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.turkishairlines.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.turkishairlines.com/en-us/any-questions/get-in-touch/ https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
   
   
    {
      name: 'united Airlines',
      logo: 'assets/airline_partner/united-Airlines.svg',
      check_flight_status:[{
        link: 'https://www.united.com/en/us',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. UA126 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.united.com/en/us',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.united.com/en/us and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.united.com/en/us/fly/customer-support/contact-directory.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Uzbekistan Airways',
      logo: 'assets/airline_partner/Uzbekistan_Airways_logo.svg.png',
      check_flight_status:[{
        link: 'https://www.uzairways.com/en/statform',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. HY250 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.uzairways.com/en',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.uzairways.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.uzairways.com/en/contact-us https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'vietnam',
      logo: 'assets/airline_partner/vna-mobile.svg',
      check_flight_status:[{
        link: 'https://www.vietnamairlines.com/nz/en/home',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. VN916 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.vietnamairlines.com/nz/en/home',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.uzairways.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.vietnamairlines.com/nz/en/support/customer-care https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'virgin atlantic',
      logo: 'assets/airline_partner/virgin-atlantic.svg',
      check_flight_status:[{
        link: 'https://www.virginatlantic.com/flight-status/search',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. VS326 Or Search by Route'
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.virginatlantic.com/PCCOciWeb/processFindPnr.action',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.uzairways.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://help.virginatlantic.com/gb/en.html https://www.airmauritius.com/contact',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
  ];


  domestic_partner =[
    {
      name: 'indigo',
      logo: 'assets/airline_partner/indigo.svg',
      check_flight_status:[{
        link: 'https://www.goindigo.in/check-flight-status.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. 6E007 Or Search by Route '
          },
          {
            data: 'Click on Search Flights '
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.goindigo.in/web-check-in.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit www.goindigo.in and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.goindigo.in/update-contact-details',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air India',
      logo: 'assets/airline_partner/Air-India.svg',
      check_flight_status:[{
        link: 'https://www.airindia.com/in/en/manage/flight-status.html',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. AI161 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airindia.com/in/en/manage/web-checkin.html',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airindia.in/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.bookme.airindia.in/AirIndiaB2C/Manage/Retrieve',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'spicejet',
      logo: 'assets/airline_partner/spicejet.png',
      check_flight_status:[{
        link: 'https://book.spicejet.com/flightstatus.aspx',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. SJ3092 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.spicejet.com/#checkin',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.spicejet.com/ and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.book.spicejet.com/RetrieveBooking',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    
    {
      name: 'Air India Express',
      logo: 'assets/airline_partner/Air_India_Ex.png',
      check_flight_status:[{
        link: 'https://www.airindiaexpress.com/checkin-home',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. I53603 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airindiaexpress.com/checkin-home',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airindiaexpress.in/en  and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airindiaexpress.in/en/contact-us/our-offices',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    {
      name: 'Air Arabia',
      logo: 'assets/airline_partner/Air_Arabia.png',
      check_flight_status:[{
        link: 'https://www.airarabia.com/en/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. IB075 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.airarabia.com/en/check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit https://www.airarabia.com/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airarabia.com/en/contact-us',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },
    // {
    //   name: 'Vistara',
    //   logo: 'assets/airline_partner/Vistara_Logo.png',
    //   check_flight_status:[{
    //     link: 'https://www.airvistara.com/in/en/flight-status',
    //     content:[
    //       {
    //         data: 'Input the Departing, Arrival and flight number, e.g. UK017 Or Search by Route '
    //       },
    //       {
    //         data: 'Click on Search Flights'
    //       }
    //     ],
    //     note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
    //   }],
    //   web_check_in:[{
    //     link: 'https://www.airvistara.com/in/en/travel-information/vistara-experience/on-ground/check-in/web-check-in',
    //     content:[
    //       {
    //         data: 'Input the PNR and Email/Last Name as per the booking '
    //       },
    //       {
    //         data: 'Select the passenger and add Nationality '
    //       },
    //       {
    //         data: 'Tick to complete the Covid-19 and other self-declarations '
    //       },
    //       {
    //         data: 'Select add ons (Seats, Baggage, etc.) and continue '
    //       }
    //     ],
    //     note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit www.airvistara.com/in/en and input the PNR details which they have already checked in.',
    //   }],
    //   update_contact:[{
    //     link: 'https://www.airvistara.com/in/en',
    //     content:[
    //       {
    //         data: 'Input the PNR, Email/Last Name & Click on Update Contact'
    //       }
    //     ],
    //     note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
    //   }],
    // },
    {
      name: 'Akasa air',
      logo: 'assets/airline_partner/Akasa-Logo.png',
      check_flight_status:[{
        link: 'https://www.akasaair.com/flight-status',
        content:[
          {
            data: 'Input the Departing, Arrival and flight number, e.g. QP1017 Or Search by Route '
          },
          {
            data: 'Click on Search Flights'
          }
        ],
        note: 'Flight Status can be checked for flights on the previous day, same day and next day.',
      }],
      web_check_in:[{
        link: 'https://www.akasaair.com/check-in/web-check-in',
        content:[
          {
            data: 'Input the PNR and Email/Last Name as per the booking '
          },
          {
            data: 'Select the passenger and add Nationality '
          },
          {
            data: 'Tick to complete the Covid-19 and other self-declarations '
          },
          {
            data: 'Select add ons (Seats, Baggage, etc.) and continue '
          }
        ],
        note: 'Guests are required to report 3 hrs prior to departure with sufficient time to complete all the formalities. To reprint the boarding pass, guests would need to visit www.airvistara.com/in/en and input the PNR details which they have already checked in.',
      }],
      update_contact:[{
        link: 'https://www.airvistara.com/in/en',
        content:[
          {
            data: 'Input the PNR, Email/Last Name & Click on Update Contact'
          }
        ],
        note: 'It is mandatory to provide a guest contact number and email ID in the booking.',
      }],
    },

  ];
  constructor() { }
}
